import script from "./MultiWindowMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiWindowMonitor.vue?vue&type=script&setup=true&lang=js"

import "./MultiWindowMonitor.vue?vue&type=style&index=0&id=2c95dda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c95dda4"]])

export default __exports__